// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LUyR","importantInfo":"styles_importantInfo__3vWwY"};